


















// 导出一个选项
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Tags extends Vue {
  // data
  selectedTags: string[] = [];
  // computed
  get tagList() {
    return this.$store.state.tagList;
  }
  // hooks
  created() {
    this.$store.commit("fetchTag");
  }
  mounted() {
    document.addEventListener(
      "touchmove",
      function(e: any) {
        if (e.cancelable) {
          if (!e.defaultPrevented) {
            e.preventDefault();
          }
        }
      },
      false
    );
  }
  // methods
  toggle(tag: string) {
    const index = this.selectedTags.indexOf(tag);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
    } else {
      this.selectedTags.push(tag);
    }
    this.$emit("update:value", this.selectedTags);
  }
  create() {
    const name = window.prompt("请输入两个字的新标签名");
    if (name === "") {
      window.alert("标签名不为空");
    } else if (name === null) {
      return;
    } else {
      this.$store.commit("createTag", name);
      window.alert("新建标签成功");
    }
  }
}
